import type { Props as SelectProps, SingleValue } from "react-select";

import { SelectInput } from "components/Select";
import { useGetStoresOptionsQuery } from "@/services/store/select-options";
import { filterClasses, getSelectClasses } from "@/utils/filter-styles";
import { formatOptionLabel } from "@/utils/format-option-label";

import { BATCH_STATUS } from "../../../constants/status";
import PeriodRangeFilter from "@/components/PeriodRangeFilter";
import { useDepositBatchesFilterActions } from "../ducks/filter/hooks/actions";
import { useDepositBatchesFilterState } from "../ducks/filter/hooks/filter-state";

type FilterOption = { value: string; label: string };

const FilterSelect = SelectInput as (
  props: SelectProps<FilterOption, false>,
) => JSX.Element;

const statusOptions: FilterOption[] = [
  { value: BATCH_STATUS.ACTIVE, label: "Ativo" },
  { value: BATCH_STATUS.UNDONE, label: "Desfeito" },
];

export default function SelectFilters() {
  const { updateFilter } = useDepositBatchesFilterActions();
  const { filters } = useDepositBatchesFilterState();

  const { data: storeOptions } = useGetStoresOptionsQuery(undefined, {
    refetchOnMountOrArgChange: false,
  });

  const handleStoreChange = (opt: SingleValue<FilterOption>) => {
    updateFilter({
      key: "storeCode",
      value: opt?.value ? Number(opt.value) : undefined,
    });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleStatusChange = (opt: SingleValue<FilterOption>) => {
    updateFilter({ key: "status", value: opt?.value ?? undefined });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const handleCommittedAtChange = (
    from: string | undefined,
    to: string | undefined,
  ) => {
    updateFilter({ key: "committedAtFrom", value: from });
    updateFilter({ key: "committedAtTo", value: to });
    updateFilter({ key: "meta", value: { page: 1 } });
  };

  const currentStore =
    (storeOptions ?? []).find(
      (o: FilterOption) => Number(o.value) === filters.storeCode,
    ) ?? null;
  const currentStatus =
    statusOptions.find(o => o.value === filters.status) ?? null;

  return (
    <div className={filterClasses.container}>
      <div className={filterClasses.filterItem}>
        <FilterSelect
          options={storeOptions ?? []}
          placeholder="Filtrar por loja"
          value={currentStore}
          onChange={handleStoreChange}
          className={getSelectClasses(currentStore !== null)}
          classNamePrefix="an-simple-select"
          isClearable
          closeMenuOnSelect
          hideSelectedOptions={false}
          formatOptionLabel={formatOptionLabel}
        />
      </div>
      <div className={filterClasses.filterItem}>
        <FilterSelect
          options={statusOptions}
          placeholder="Filtrar por status"
          value={currentStatus}
          onChange={handleStatusChange}
          className={getSelectClasses(currentStatus !== null)}
          classNamePrefix="an-simple-select"
          isClearable
          closeMenuOnSelect
          hideSelectedOptions={false}
          formatOptionLabel={formatOptionLabel}
        />
      </div>
      <div className={filterClasses.filterItem}>
        <PeriodRangeFilter
          start={filters.committedAtFrom}
          end={filters.committedAtTo}
          onChange={handleCommittedAtChange}
          label="Conciliado em"
          inline
        />
      </div>
    </div>
  );
}
